<div class="asset-creation-container">
    <!-- Header -->
    <div class="asset-header">
        <h2 class="header-title">Create Asset</h2>
        <div class="header-actions">
            <button class="btn-secondary">Cancel</button>
            <button class="btn-primary" (click)="saveCompleteConfiguration()">Save Asset</button>
        </div>
    </div>

    <!-- Main Content -->
    <div class="asset-content">
        <!-- Left Section - Preview -->
        <div class="left-section">
            <div class="preview-card">
                <div class="preview-header">
                    <h3>Asset Templates</h3>
                </div>

                <div class="template-preview" (click)="openPiezeoPreview()">
                    <div class="blur-preview">
                        <img [src]="subsystem_data.Image_path" alt="Piezeo Template" class="preview-image">
                        <div class="preview-overlay">
                            <span class="preview-text">Click to Preview</span>
                            <p class="template-name">Piezeo Template</p>
                        </div>
                    </div>
                </div>

                <div class="template-info">
                    <div class="info-badge">
                        <span class="badge-label">Template Type:</span>
                        <span class="badge-value">Frame Asset</span>
                    </div>
                    <div class="info-badge">
                        <span class="badge-label">Status:</span>
                        <span class="badge-value status-active">Active</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Section - Form Content with Tabs -->
        <div class="right-section">
            <mat-tab-group animationDuration="300ms" (selectedTabChange)="onTabChange($event)" class="asset-form-tabs">
                <mat-tab label="Gateway Configuration">
                    <div class="gateway-config-container">
                        <!-- Header Row -->
                        <div class="gateway-header">
                            <h3 class="gateway-title">All Gateways</h3>
                            <button mat-flat-button color="primary" class="add-gateway-btn" (click)="addGateway()">
                                <i class="fas fa-plus"></i> Add Gateway
                            </button>
                        </div>

                        <!-- Gateway Cards -->
                        <div class="gateway-list">
                            <div class="gateway-card" *ngFor="let g of configured_gateways">
                                <div class="gateway-info">
                                    <p class="gateway-label"></p>
                                    <p class="gateway-value">
                                        <!-- <button mat-stroked-button color="warning" (click)="deleteGateway(g)">X</button>  -->
                                        <button mat-stroked-button color="warning" (click)="editGateway(g)">Edit</button></p>
                                </div>
                                <div class="gateway-info">
                                    <p class="gateway-label">MAC Address:</p>
                                    <p class="gateway-value">{{ g.gatewayAddress.mac_address }}</p>
                                </div>
                                <div class="gateway-info">
                                    <p class="gateway-label">Axis Added:</p>
                                    <p class="gateway-value">{{ g.curr_axis }}/{{ g.max_axis }}</p>
                                </div>
                                <div class="gateway-info">
                                    <p class="gateway-label">Devices Associated:</p>
                                    <p class="gateway-value">{{ g.device_associated }}</p>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="gateway-info">
                                        <div class="gateway-label">Configure Devices:</div>
                                    </div>
                                    <button mat-raised-button color="warning" class="add-gateway-btn"
                                        (click)="associateSensorToGateway(g)">
                                        Add Device
                                    </button>
                                </div>
                                <div class="gateway-associated-sensors">
                                    <div [ngStyle]="{display:s.gateway_id && s.gateway_id==g.gatewayAddress.id?'':'none'}"
                                        (click)="addPiezeo(s,g)"
                                        [ngClass]="{'is_configured':s.configured,'is_not_configured':!s.configured}"
                                        *ngFor="let s of all_sensors">
                                        @if(s.gateway_id && s.gateway_id==g.gatewayAddress.id){
                                        {{s.sensorDNames}}
                                        }
                                    </div>
                                </div>
                            </div>

                            <!-- No gateways -->
                            <div class="no-gateways" *ngIf="!configured_gateways?.length">
                                <i class="fas fa-server"></i>
                                <p>No gateways configured yet</p>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Piezo Configuration">
                    <div class="rotating-asset-form-container">
                        <form [formGroup]="rotating_asset_form" class="rotating-asset-config-form">

                            <!-- Sensor Information Section -->
                            <div class="form-section sensor-info-section" *ngIf="current_sensor != null">
                                <h3 class="form-section-title">Sensor Information</h3>
                                <div class="sensor-info-grid">
                                    <div class="info-item">
                                        <span class="info-label">Asset Type:</span>
                                        <span class="info-value">{{ current_sensor?.assetType || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item" *ngIf="current_sensor?.assetType === 'MOTOR'">
                                        <span class="info-label">Sub Type:</span>
                                        <span class="info-value">{{ current_sensor?.subType || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Asset Marker:</span>
                                        <span class="info-value">{{ current_sensor?.assetMarker || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Marker:</span>
                                        <span class="info-value">{{ current_sensor?.sensorMarker || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Name:</span>
                                        <span class="info-value">{{ current_sensor?.sensorDNames || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Number:</span>
                                        <span class="info-value">{{ current_sensor?.sensor_number || 0 }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- All Sensors List Section -->
                            <div class="form-section all-sensors-section">
                                <h3 class="form-section-title">All Sensors</h3>
                                <div class="sensors-list-container">
                                    <div class="sensors-list">
                                        <div *ngFor="let sensor of all_sensors" class="sensor-card" [ngClass]="{
                                        'selected': sensor.sensor_number === current_sensor?.sensor_number,
                                        'configured': sensor.form_configured === true,
                                        'selected-configured': sensor.form_configured === true && sensor.sensor_number === current_sensor?.sensor_number
                                        }" (click)="onSensorSelect(sensor)">
                                            <div class="sensor-card-header">
                                                <span class="sensor-number">#{{sensor.sensor_number}}</span>
                                                <span class="sensor-marker-badge">{{ sensor.sensorMarker }}</span>
                                            </div>
                                            <div class="sensor-card-body">
                                                <div class="sensor-name">{{ sensor.sensorDNames }}</div>
                                                <div class="sensor-type">{{ sensor.assetType | titlecase }}</div>
                                                <div class="sensor-subtype" *ngIf="sensor.subType">
                                                    {{ sensor.subType.replace('_', ' ') | titlecase }}
                                                </div>
                                            </div>
                                            <div class="sensor-card-footer">
                                                <!-- <span class="asset-marker-tag">{{ sensor.assetMarker }}</span> -->
                                                <span class="asset-marker-tag">{{ current_sensor?.sensorMarker + ' ' + current_sensor?.sensorDNames }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="current_sensor != null">

                            <!-- General Details Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">General Details</h3>
                                <div formGroupName="general_details" class="form-fields-row">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Asset Name</mat-label>
                                        <input matInput formControlName="asset_name" placeholder="Enter asset name">
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.asset_name')?.hasError('required')">
                                            Asset name is required
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Site</mat-label>
                                        <mat-select formControlName="site" (selectionChange)="handleSiteChange($event)">
                                            <mat-option value={{s.id}} *ngFor="let s of sites">{{s.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.site')?.invalid && rotating_asset_form.get('general_details.site')?.touched">
                                            Site is required
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Application</mat-label>
                                        <mat-select formControlName="application">
                                            <mat-option value={{a.id}}
                                                *ngFor="let a of applications">{{a.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.application')?.hasError('required')">
                                            Application is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Configuration Details Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">Configuration Details</h3>
                                <div formGroupName="configuration_details">

                                    <!-- Row 1 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Line Current</mat-label>
                                            <input matInput type="number" formControlName="line_current"
                                                placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Device Name</mat-label>
                                            <input matInput formControlName="device_name"
                                                placeholder="Enter device name">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.device_name')?.invalid && rotating_asset_form.get('configuration_details.device_name')?.touched">
                                                Device name is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 2 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="!current_sensor.form_configured">
                                            <mat-label>Device ID</mat-label>
                                            <mat-select formControlName="mac_address"
                                                (selectionChange)="onMacAddressChange($event)">
                                                <mat-option *ngFor="let d of available_devices" [value]="d">
                                                    {{ d.mac_address }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.mac_address')?.hasError('required')">
                                                Device ID is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.form_configured">
                                            <mat-label>Motor Make</mat-label>
                                            <input matInput
                                                [value]="saved_rotating_asset_data[current_sensor?.sensor_number]?.configuration_details?.mac_address?.mac_address"
                                                disabled placeholder="Enter motor make">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Motor Make*</mat-label>
                                            <input matInput formControlName="motor_make" placeholder="Enter motor make">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 3 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field full-width">
                                            <mat-label>Equipment Location</mat-label>
                                            <input matInput formControlName="equipment_location"
                                                placeholder="Enter location">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 4 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Frame</mat-label>
                                            <input matInput formControlName="frame" placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Ambient Temperature</mat-label>
                                            <input matInput type="number" formControlName="rated_amb_temp"
                                                placeholder="0">
                                        </mat-form-field>

                                        <div class="form-field temp-unit-group">
                                            <!-- <label class="unit-label">Temperature Unit</label> -->
                                            <mat-radio-group formControlName="rated_amb_temp_unit"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="C">°C</mat-radio-button>
                                                <mat-radio-button value="F">F</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Row 5 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Insulation Class</mat-label>
                                            <!-- <input matInput formControlName="insulation_class" placeholder="F">\ -->
                                            <mat-select formControlName="insulation_class">
                                                <mat-option *ngFor="let c of ['A','B','F','H']" [value]="c"
                                                    placeholder="F">
                                                    {{ c }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.insulation_class')?.hasError('required')">
                                                Insulation class is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Serial Number</mat-label>
                                            <input matInput formControlName="serial_number"
                                                placeholder="Enter serial number">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.serial_number')?.hasError('required')">
                                                Serial number is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 6 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Power</mat-label>
                                            <input matInput type="number" formControlName="rated_power"
                                                placeholder="1824">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.rated_power')?.hasError('required')">
                                                Rated power is required
                                            </mat-error>
                                        </mat-form-field>

                                        <div class="form-field power-unit-group">
                                            <!-- <label class="unit-label">Power Unit</label> -->
                                            <mat-radio-group class="radio-group-horizontal"
                                                formControlName="rated_power_unit">
                                                <mat-radio-button value="KW" [checked]="true">kW</mat-radio-button>
                                                <mat-radio-button value="fi">HP</mat-radio-button>
                                            </mat-radio-group>
                                        </div>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated RPM</mat-label>
                                            <input matInput type="number" formControlName="rated_rpm" placeholder="1000"
                                                min="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.rated_rpm')?.hasError('required')">
                                                Rated RPM is required
                                            </mat-error>
                                        </mat-form-field>

                                        <div class="form-field rpm-type-group">
                                            <!-- <label class="unit-label">RPM Type</label> -->
                                            <mat-radio-group formControlName="rated_rpm_type"
                                                (change)="onRpmChange($event)" class="radio-group-horizontal">
                                                <mat-radio-button value="fixed">Fixed</mat-radio-button>
                                                <mat-radio-button value="variable">Variable</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('configuration_details.rated_rpm_type').value == 'variable'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Min Rated Power</mat-label>
                                            <input matInput type="number" formControlName="min_rpm" placeholder="0"
                                                min="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.min_rpm')?.hasError('required')">
                                                Max Rated power is required
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Max Rated Power</mat-label>
                                            <input matInput type="number" formControlName="max_rpm" placeholder="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.max_rpm')?.hasError('required')">
                                                Max Rated power is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 7 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Voltage</mat-label>
                                            <input matInput type="number" formControlName="rated_voltage"
                                                placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Percentage Efficiency</mat-label>
                                            <input matInput type="number" formControlName="percentage_eff"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 8 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Line Frequency</mat-label>
                                            <input matInput type="number" min="0" max="100" formControlName="line_freq"
                                                placeholder="50">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.line_freq')?.hasError('required')">
                                                Line frequency is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Power Factor</mat-label>
                                            <input matInput type="number" formControlName="power_factor"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 9 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Duty</mat-label>
                                            <input matInput formControlName="duty" placeholder="Enter duty">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.assetType=='MOTOR'">
                                            <mat-label>Number Of Pole Pairs</mat-label>
                                            <input matInput type="number" formControlName="pole_pairs" placeholder="0"
                                                min="0">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.assetType=='PUMP'">
                                            <mat-label>Number of Blades</mat-label>
                                            <input matInput type="number" formControlName="no_of_blades" placeholder="0"
                                                min="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Bearing Type -->
                                    <div class="form-fields-row" *ngIf="this.current_sensor.assetType != 'GEAR'">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="bearing_type"
                                                (change)="onBearingChange($event)" class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers - for all except gear -->
                                    <div class="form-fields-row" *ngIf="this.current_sensor.assetType != 'GEAR'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="de_number">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="nde_number">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <!-- GEAR FORM STARTS -->
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <!-- PINION GEAR DETAILS -->
                                <h3 class="form-section-title">Pinion Gear Details</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.pinion_gear_details')">
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Number Of Stages</mat-label>
                                            <input matInput formControlName="number_of_stages" placeholder="No. of stages">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Pinion Gear RPM *</mat-label>
                                            <input matInput formControlName="p_gear_rpm" placeholder="Pinion Gear RPM">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of teeth for Pinion Gear</mat-label>
                                            <input matInput formControlName="p_gear_teeth"
                                                placeholder="Pinion Gear Teeth">
                                        </mat-form-field>
                                    </div>
                                    <!-- Bearing Type -->
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="p_bearing_type"
                                                (change)="onBearingChange($event,'p_bearing_type')"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="p_deb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="p_ndeb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <h3 class="form-section-title">Output Gear Details</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.output_gear_details')">
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of Output Gears*</mat-label>
                                            <input matInput formControlName="no_of_opt_gears"
                                                placeholder="No. of Output Gears">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Output Gear RPM</mat-label>
                                            <input matInput formControlName="o_gear_rpm" placeholder="Pinion Gear RPM">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of teeth for Output Gear</mat-label>
                                            <input matInput formControlName="o_gear_teeth"
                                                placeholder="Pinion Gear Teeth">
                                        </mat-form-field>
                                    </div>
                                    <!-- Bearing Type -->
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="o_bearing_type"
                                                (change)="onBearingChange($event,'o_bearing_type')"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="o_deb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="o_ndeb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- GMF -->
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <h3 class="form-section-title">Gear Mesh Frequency</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.gmf_details')">
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Do you know Gear Mesh Frequency (GMF)?</label>
                                            <mat-radio-group formControlName="is_gmf" class="radio-group-horizontal">
                                                <mat-radio-button value="gmf_enabled">Yes</mat-radio-button>
                                                <mat-radio-button value="gmf_disabled">No</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row" *ngIf="gmf_enabled.value=='gmf_enabled'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of GMF *</mat-label>
                                            <mat-select formControlName="no_of_gmf">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of [1,2,3,4,5,6,7,8]">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div formArrayName="gmf_list" class="gmf-list">
                                        <div class="gmf-row" *ngFor="let group of gmf_list.controls; let i = index"
                                            [formGroupName]="i">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>GMF [{{ i + 1 }}]</mat-label>
                                                <input matInput formControlName="gmf_value" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Number For GMF [{{ i + 1 }}]</mat-label>
                                                <input matInput formControlName="number_for_gmf" />
                                            </mat-form-field>

                                            <!-- <button mat-button color="warn" (click)="removeGMF(i)">Remove</button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- GEAR FORM ENDS -->

                            <!-- Drive Details Section -->
                            <div class="form-section" *ngIf="current_sensor.assetType != 'GEAR'">
                                <h3 class="form-section-title">Drive Details</h3>
                                <div formGroupName="drive_details">
                                    <div class="form-fields-row">
                                        <div class="form-field drive-type-group">
                                            <label class="unit-label">Drive Type</label>
                                            <mat-radio-group formControlName="drive_type"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="direct">Direct Drive</mat-radio-button>
                                                <mat-radio-button value="pulley">Pulley Belt Drive</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('drive_details.drive_type').value != 'direct'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Driver Pulley Diameter *</mat-label>
                                            <input matInput formControlName="driver_pulley_diameter" min="0"
                                                type="number" placeholder="Enter duty">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Driven Pulley Diameter *</mat-label>
                                            <input matInput type="number" formControlName="driven_pulley_diameter"
                                                min="0" placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Distance Between Shaft Centers *</mat-label>
                                            <input matInput type="number" formControlName="dist_bt_shaft" min="0"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('drive_details.drive_type').value != 'direct'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Belt Number *</mat-label>
                                            <input matInput formControlName="belt_no" placeholder="Belt Number"
                                                type="number" min="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Belt Length *</mat-label>
                                            <input matInput type="number" min="0" formControlName="belt_length"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <!-- Other Configurations Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">Other Configuration</h3>
                                <div formGroupName="other_configurations">

                                    <!-- Mounting Axis Options -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Mounting Axis Options</h4>
                                        <div class="form-fields-row">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Sensor Mounting Axis Options</mat-label>
                                                <mat-select formControlName="sensor_mounting">
                                                    <mat-option value="PARALLEL_SIDE">Parallel to the Machine Shaft
                                                        (Side)</mat-option>
                                                    <mat-option value="PARALLEL_TOP">Perpendicular to Machine
                                                        Shaft</mat-option>
                                                    <mat-option value="PERPENDICULAR">Axial Direction</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Temperature Sensor Location -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Temperature Sensor Location</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD1</mat-label>
                                                <mat-select formControlName="RTD_1">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD2</mat-label>
                                                <mat-select formControlName="RTD_2">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD3</mat-label>
                                                <mat-select formControlName="RTD_3">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Temperature Compensation -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Temperature Compensation (°C)</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 1</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_1_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 2</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_2_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 3</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_3_comp">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Vibration Compensation -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Vibration compensation</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Radial (Horizontal)</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_1_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Tangential (Vertical)</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_2_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Axial</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_3_comp">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Calibration Status -->
                                    <div class="calibration-status">
                                        <p class="status-text">Last Calibrated: No Calibration Had Been Done Yet</p>
                                        <div class="calibration-actions">
                                            <button mat-stroked-button color="warn" type="button">Reset Values</button>
                                            <button mat-flat-button color="primary" type="button">Calibrate</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- Form Actions -->
                            <div class="form-actions">
                                <button mat-flat-button color="warn" type="button" (click)="resetForm()">Clear</button>
                                <button mat-flat-button color="primary" type="button" (click)="saveCurrentAsset()"
                                    [disabled]="rotating_asset_form.invalid || !rotating_asset_form.dirty">
                                    Save Configuration
                                </button>
                            </div>

                            </div>
                            <div class="" *ngIf="current_sensor == null">
                                <h3>NO CURRENT SENSOR</h3>
                            </div>
                        </form>
                    </div>
                </mat-tab>
                
                
                <!-- ===================================================================================================================================== -->
                <!-- ===================================================================================================================================== -->
                <!-- ====================================================EMSAVER(s) ONLY================================================================= -->
                <!-- ===================================================================================================================================== -->
                <!-- ===================================================================================================================================== -->
                
                <mat-tab label="Rotating Asset Configuration">
                    <div class="rotating-asset-form-container">
                        <form [formGroup]="rotating_asset_form" class="rotating-asset-config-form">

                            <!-- Sensor Information Section -->
                            <div class="form-section sensor-info-section" *ngIf="current_sensor != null">
                                <h3 class="form-section-title">Sensor Information</h3>
                                <div class="sensor-info-grid">
                                    <div class="info-item">
                                        <span class="info-label">Asset Type:</span>
                                        <span class="info-value">{{ current_sensor?.assetType || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item" *ngIf="current_sensor?.assetType === 'MOTOR'">
                                        <span class="info-label">Sub Type:</span>
                                        <span class="info-value">{{ current_sensor?.subType || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Asset Marker:</span>
                                        <span class="info-value">{{ current_sensor?.assetMarker || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Type:</span>
                                        <span class="info-value">{{ 
                                            current_sensor.master_type==1?'Em-Mini':current_sensor.master_type==2?'EM-Standard':'EM-standard + RTDs'
                                          }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Name:</span>
                                        <span class="info-value">{{ current_sensor?.sensorDNames || 'N/A' }}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">Sensor Number:</span>
                                        <span class="info-value">{{ current_sensor?.sensor_number || 0 }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- All Sensors List Section -->
                            <div class="form-section all-sensors-section">
                                <h3 class="form-section-title">All Sensors</h3>
                                <div class="sensors-list-container">
                                    <div class="sensors-list">
                                        <div *ngFor="let sensor of emsaver_sensors" class="sensor-card" [ngClass]="{
                                        'selected': sensor.sensor_number === current_sensor?.sensor_number,
                                        'configured': sensor.form_configured === true,
                                        'selected-configured': sensor.form_configured === true && sensor.sensor_number === current_sensor?.sensor_number
                                        }" (click)="onSensorSelect(sensor)">
                                            <div class="sensor-card-header">
                                                <span class="sensor-number">#{{sensor.sensor_number}}</span>
                                                <span class="sensor-marker-badge">{{ sensor.sensorMarker }}</span>
                                            </div>
                                            <div class="sensor-card-body">
                                                <div class="sensor-name">{{ sensor.sensorDNames }}</div>
                                                <div class="sensor-type">{{ sensor.assetType | titlecase }}</div>
                                                <div class="sensor-subtype" *ngIf="sensor.subType">
                                                    {{ sensor.subType.replace('_', ' ') | titlecase }}
                                                </div>
                                            </div>
                                            <div class="sensor-card-footer">
                                                <span class="asset-marker-tag">{{ sensor.assetMarker }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          <ng-template *ngIf="current_sensor != null" >
                            <!-- General Details Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">General Details</h3>
                                <div formGroupName="general_details" class="form-fields-row">
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Asset Name</mat-label>
                                        <input matInput formControlName="asset_name" placeholder="Enter asset name">
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.asset_name')?.hasError('required')">
                                            Asset name is required
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Site</mat-label>
                                        <mat-select formControlName="site" (selectionChange)="handleSiteChange($event)">
                                            <mat-option value={{s.id}} *ngFor="let s of sites">{{s.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.site')?.invalid && rotating_asset_form.get('general_details.site')?.touched">
                                            Site is required
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-label>Application</mat-label>
                                        <mat-select formControlName="application">
                                            <mat-option value={{a.id}}
                                                *ngFor="let a of applications">{{a.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="rotating_asset_form.get('general_details.application')?.hasError('required')">
                                            Application is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Push Rate Configuration Details Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">Device Configuration</h3>

                                <div formGroupName="device_push_rate_configuration" class="form-fields-row">

                                <!-- Sensor Summarize Data Frequency -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Sensor Summarize Data Frequency (mins)</mat-label>
                                <input matInput type="number" formControlName="summaryFileRefreshRate" placeholder="Enter minutes">
                                <mat-error *ngIf="rotating_asset_form.get('device_configuration.summaryFileRefreshRate')?.hasError('required')">
                                    Required
                                </mat-error>
                                </mat-form-field>

                                <!-- High Res Data Push Rate -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>High Res Data Push Rate (mins)</mat-label>
                                <input matInput type="number" formControlName="fullRefreshFileRate" placeholder="Enter minutes">
                                <mat-error *ngIf="rotating_asset_form.get('device_configuration.fullRefreshFileRate')?.hasError('required')">
                                    Required
                                </mat-error>
                                </mat-form-field>

                                <!-- Scan Rate -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Scan Rate (sec)</mat-label>
                                <input matInput type="number" formControlName="scanRate" placeholder="Enter seconds">
                                <mat-error *ngIf="rotating_asset_form.get('device_configuration.scanRate')?.hasError('required')">
                                    Required
                                </mat-error>
                                </mat-form-field>

                                </div>

                                <!-- SECOND ROW -->
                                <div formGroupName="device_push_rate_configuration" class="form-fields-row">

                                    <!-- ODR Normal -->
                                    <mat-form-field appearance="outline" class="form-field">
                                    <mat-label>ODR Normal</mat-label>
                                    <mat-select formControlName="odr_normal">
                                        <mat-option *ngFor="let o of odr_options" [value]="o.value">
                                        {{ o.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="rotating_asset_form.get('device_configuration.odr_normal')?.hasError('required')">
                                        Required
                                    </mat-error>
                                    </mat-form-field>

                                    <!-- ODR High Res -->
                                    <mat-form-field appearance="outline" class="form-field">
                                    <mat-label>ODR High Res</mat-label>
                                    <mat-select formControlName="odr_high_res">
                                        <mat-option *ngFor="let o of odr_options" [value]="o.value">
                                        {{ o.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="rotating_asset_form.get('device_configuration.odr_high_res')?.hasError('required')">
                                        Required
                                    </mat-error>
                                    </mat-form-field>

                                    <!-- Anomaly Analysis Frequency -->
                                    <mat-form-field appearance="outline" class="form-field">
                                    <mat-label>Anomaly Analysis Frequency (mins)</mat-label>
                                    <input matInput type="number" formControlName="anomalyAnalysisTime" placeholder="Enter minutes">
                                    <mat-error *ngIf="rotating_asset_form.get('device_configuration.anomalyAnalysisTime')?.hasError('required')">
                                        Required
                                    </mat-error>
                                    </mat-form-field>

                                    <!-- Anomaly Counter -->
                                    <mat-form-field appearance="outline" class="form-field">
                                    <mat-label>Anomaly Counter</mat-label>
                                    <input matInput type="number" formControlName="anomalyCounter" placeholder="Enter count">
                                    <mat-error *ngIf="rotating_asset_form.get('device_configuration.anomalyCounter')?.hasError('required')">
                                        Required
                                    </mat-error>
                                    </mat-form-field>
                                    <!-- Anomaly Counter -->
                                    <mat-form-field appearance="outline" class="form-field">
                                    <mat-label>Machine Threshold Value</mat-label>
                                    <input matInput type="number" formControlName="machine_threshold_status" placeholder="0.5">
                                    <mat-error *ngIf="rotating_asset_form.get('device_configuration.machine_threshold_status')?.hasError('required')">
                                        Required
                                    </mat-error>
                                    </mat-form-field>

                                </div>
                            </div>

                            <!-- Configuration Details Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">Configuration Details</h3>
                                <div formGroupName="configuration_details">

                                    <!-- Row 1 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Line Current</mat-label>
                                            <input matInput type="number" formControlName="line_current"
                                                placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Device Name</mat-label>
                                            <input matInput formControlName="device_name"
                                                placeholder="Enter device name">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.device_name')?.invalid && rotating_asset_form.get('configuration_details.device_name')?.touched">
                                                Device name is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 2 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="!current_sensor.form_configured">
                                            <mat-label>Device ID</mat-label>
                                            <mat-select formControlName="mac_address"
                                                (selectionChange)="onMacAddressChange($event)">
                                                @if (current_sensor.master_type==1) {
                                                    <mat-option *ngFor="let d of emsaver_available_devices.emsaver_mini" [value]="d">
                                                        {{ d.mac_address }}
                                                    </mat-option>
                                                }
                                                @if (current_sensor.master_type==2) {
                                                    <mat-option *ngFor="let d of emsaver_available_devices.emsaver_std" [value]="d">
                                                        {{ d.mac_address }}
                                                    </mat-option>
                                                }
                                                @if (current_sensor.master_type==3) {
                                                    <mat-option *ngFor="let d of emsaver_available_devices.emsaver_rtds" [value]="d">
                                                        {{ d.mac_address }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.mac_address')?.hasError('required')">
                                                Device ID is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.form_configured">
                                            <mat-label>Motor Make</mat-label>
                                            <input matInput
                                                [value]="saved_rotating_asset_data[current_sensor?.sensor_number]?.configuration_details?.mac_address?.mac_address"
                                                disabled placeholder="Enter motor make">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Motor Make*</mat-label>
                                            <input matInput formControlName="motor_make" placeholder="Enter motor make">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 3 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field full-width">
                                            <mat-label>Equipment Location</mat-label>
                                            <input matInput formControlName="equipment_location"
                                                placeholder="Enter location">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 4 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Frame</mat-label>
                                            <input matInput formControlName="frame" placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Ambient Temperature</mat-label>
                                            <input matInput type="number" formControlName="rated_amb_temp"
                                                placeholder="0">
                                        </mat-form-field>

                                        <div class="form-field temp-unit-group">
                                            <!-- <label class="unit-label">Temperature Unit</label> -->
                                            <mat-radio-group formControlName="rated_amb_temp_unit"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="C">°C</mat-radio-button>
                                                <mat-radio-button value="F">F</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Row 5 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Insulation Class</mat-label>
                                            <!-- <input matInput formControlName="insulation_class" placeholder="F">\ -->
                                            <mat-select formControlName="insulation_class">
                                                <mat-option *ngFor="let c of ['A','B','F','H']" [value]="c"
                                                    placeholder="F">
                                                    {{ c }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.insulation_class')?.hasError('required')">
                                                Insulation class is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Serial Number</mat-label>
                                            <input matInput formControlName="serial_number"
                                                placeholder="Enter serial number">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.serial_number')?.hasError('required')">
                                                Serial number is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 6 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Power</mat-label>
                                            <input matInput type="number" formControlName="rated_power"
                                                placeholder="1824">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.rated_power')?.hasError('required')">
                                                Rated power is required
                                            </mat-error>
                                        </mat-form-field>

                                        <div class="form-field power-unit-group">
                                            <!-- <label class="unit-label">Power Unit</label> -->
                                            <mat-radio-group class="radio-group-horizontal"
                                                formControlName="rated_power_unit">
                                                <mat-radio-button value="KW" [checked]="true">kW</mat-radio-button>
                                                <mat-radio-button value="fi">HP</mat-radio-button>
                                            </mat-radio-group>
                                        </div>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated RPM</mat-label>
                                            <input matInput type="number" formControlName="rated_rpm" placeholder="1000"
                                                min="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.rated_rpm')?.hasError('required')">
                                                Rated RPM is required
                                            </mat-error>
                                        </mat-form-field>

                                        <div class="form-field rpm-type-group">
                                            <!-- <label class="unit-label">RPM Type</label> -->
                                            <mat-radio-group formControlName="rated_rpm_type"
                                                (change)="onRpmChange($event)" class="radio-group-horizontal">
                                                <mat-radio-button value="fixed">Fixed</mat-radio-button>
                                                <mat-radio-button value="variable">Variable</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('configuration_details.rated_rpm_type').value == 'variable'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Min Rated Power</mat-label>
                                            <input matInput type="number" formControlName="min_rpm" placeholder="0"
                                                min="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.min_rpm')?.hasError('required')">
                                                Max Rated power is required
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Max Rated Power</mat-label>
                                            <input matInput type="number" formControlName="max_rpm" placeholder="0">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.max_rpm')?.hasError('required')">
                                                Max Rated power is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 7 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Rated Voltage</mat-label>
                                            <input matInput type="number" formControlName="rated_voltage"
                                                placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Percentage Efficiency</mat-label>
                                            <input matInput type="number" formControlName="percentage_eff"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 8 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Line Frequency</mat-label>
                                            <input matInput type="number" min="0" max="100" formControlName="line_freq"
                                                placeholder="50">
                                            <mat-error
                                                *ngIf="rotating_asset_form.get('configuration_details.line_freq')?.hasError('required')">
                                                Line frequency is required
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Power Factor</mat-label>
                                            <input matInput type="number" formControlName="power_factor"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Row 9 -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Duty</mat-label>
                                            <input matInput formControlName="duty" placeholder="Enter duty">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.assetType=='MOTOR'">
                                            <mat-label>Number Of Pole Pairs</mat-label>
                                            <input matInput type="number" formControlName="pole_pairs" placeholder="0"
                                                min="0">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field"
                                            *ngIf="current_sensor.assetType=='PUMP'">
                                            <mat-label>Number of Blades</mat-label>
                                            <input matInput type="number" formControlName="no_of_blades" placeholder="0"
                                                min="0">
                                        </mat-form-field>
                                    </div>

                                    <!-- Bearing Type -->
                                    <div class="form-fields-row" *ngIf="this.current_sensor.assetType != 'GEAR'">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="bearing_type"
                                                (change)="onBearingChange($event)" class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers - for all except gear -->
                                    <div class="form-fields-row" *ngIf="this.current_sensor.assetType != 'GEAR'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="de_number">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="nde_number">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <!-- GEAR FORM STARTS -->
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <!-- PINION GEAR DETAILS -->
                                <h3 class="form-section-title">Pinion Gear Details</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.pinion_gear_details')">
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Number Of Stages</mat-label>
                                            <input matInput formControlName="no_of_stages" placeholder="No. of stages">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Pinion Gear RPM *</mat-label>
                                            <input matInput formControlName="p_gear_rpm" placeholder="Pinion Gear RPM">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of teeth for Pinion Gear</mat-label>
                                            <input matInput formControlName="p_gear_teeth"
                                                placeholder="Pinion Gear Teeth">
                                        </mat-form-field>
                                    </div>
                                    <!-- Bearing Type -->
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="p_bearing_type"
                                                (change)="onBearingChange($event,'p_bearing_type')"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="p_deb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="p_ndeb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <h3 class="form-section-title">Output Gear Details</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.output_gear_details')">
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of Output Gears*</mat-label>
                                            <input matInput formControlName="no_of_opt_gears"
                                                placeholder="No. of Output Gears">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Output Gear RPM</mat-label>
                                            <input matInput formControlName="o_gear_rpm" placeholder="Pinion Gear RPM">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of teeth for Output Gear</mat-label>
                                            <input matInput formControlName="o_gear_teeth"
                                                placeholder="Pinion Gear Teeth">
                                        </mat-form-field>
                                    </div>
                                    <!-- Bearing Type -->
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Bearing Type</label>
                                            <mat-radio-group formControlName="o_bearing_type"
                                                (change)="onBearingChange($event,'o_bearing_type')"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                                <mat-radio-button value="sleeve_bearing">Sleeve
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>

                                    <!-- Bearing Numbers -->
                                    <div class="form-fields-row">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>DE Bearing Number</mat-label>
                                            <mat-select formControlName="o_deb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>NDE Bearing Number</mat-label>
                                            <mat-select formControlName="o_ndeb_no">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of bearing_numbers">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions-inline">
                                        <button mat-flat-button color="primary" type="button" class="add-bearing-btn">
                                            Add Bearing Number
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- GMF -->
                            <div class="form-section" *ngIf="this.current_sensor.assetType=='GEAR'">
                                <h3 class="form-section-title">Gear Mesh Frequency</h3>
                                <div [formGroup]="rotating_asset_form.get('configuration_details.gmf_details')">
                                    <div class="form-fields-row">
                                        <div class="form-field bearing-type-group">
                                            <label class="unit-label">Do you know Gear Mesh Frequency (GMF)?</label>
                                            <mat-radio-group formControlName="is_gmf" class="radio-group-horizontal">
                                                <mat-radio-button value="gmf_enabled">Yes</mat-radio-button>
                                                <mat-radio-button value="gmf_disabled">No
                                                    Bearing</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row" *ngIf="gmf_enabled.value=='gmf_enabled'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>No. of GMF *</mat-label>
                                            <mat-select formControlName="no_of_gmf">
                                                <mat-option value={{b}}
                                                    *ngFor="let b of [1,2,3,4,5,6,7,8]">{{b}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div formArrayName="gmf_list" class="gmf-list">
                                        <div class="gmf-row" *ngFor="let group of gmf_list.controls; let i = index"
                                            [formGroupName]="i">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>GMF [{{ i + 1 }}]</mat-label>
                                                <input matInput formControlName="gmf_value" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Number For GMF [{{ i + 1 }}]</mat-label>
                                                <input matInput formControlName="number_for_gmf" />
                                            </mat-form-field>

                                            <!-- <button mat-button color="warn" (click)="removeGMF(i)">Remove</button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- GEAR FORM ENDS -->

                            <!-- Drive Details Section -->
                            <div class="form-section" *ngIf="current_sensor.assetType != 'GEAR'">
                                <h3 class="form-section-title">Drive Details</h3>
                                <div formGroupName="drive_details">
                                    <div class="form-fields-row">
                                        <div class="form-field drive-type-group">
                                            <label class="unit-label">Drive Type</label>
                                            <mat-radio-group formControlName="drive_type"
                                                class="radio-group-horizontal">
                                                <mat-radio-button value="direct">Direct Drive</mat-radio-button>
                                                <mat-radio-button value="pulley">Pulley Belt Drive</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('drive_details.drive_type').value != 'direct'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Driver Pulley Diameter *</mat-label>
                                            <input matInput formControlName="driver_pulley_diameter" min="0"
                                                type="number" placeholder="Enter duty">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Driven Pulley Diameter *</mat-label>
                                            <input matInput type="number" formControlName="driven_pulley_diameter"
                                                min="0" placeholder="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Distance Between Shaft Centers *</mat-label>
                                            <input matInput type="number" formControlName="dist_bt_shaft" min="0"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-fields-row"
                                        *ngIf="rotating_asset_form.get('drive_details.drive_type').value != 'direct'">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Belt Number *</mat-label>
                                            <input matInput formControlName="belt_no" placeholder="Belt Number"
                                                type="number" min="0">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Belt Length *</mat-label>
                                            <input matInput type="number" min="0" formControlName="belt_length"
                                                placeholder="0">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <!-- Other Configurations Section -->
                            <div class="form-section">
                                <h3 class="form-section-title">Other Configuration</h3>
                                <div formGroupName="other_configurations">

                                    <!-- Mounting Axis Options -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Mounting Axis Options</h4>
                                        <div class="form-fields-row">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Sensor Mounting Axis Options</mat-label>
                                                <mat-select formControlName="sensor_mounting">
                                                    <mat-option value="PARALLEL_SIDE">Parallel to the Machine Shaft
                                                        (Side)</mat-option>
                                                    <mat-option value="PARALLEL_TOP">Perpendicular to Machine
                                                        Shaft</mat-option>
                                                    <mat-option value="PERPENDICULAR">Axial Direction</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Temperature Sensor Location -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Temperature Sensor Location</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD1</mat-label>
                                                <mat-select formControlName="RTD_1">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD2</mat-label>
                                                <mat-select formControlName="RTD_2">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>RTD3</mat-label>
                                                <mat-select formControlName="RTD_3">
                                                    <mat-option value="MS">Machine Skin</mat-option>
                                                    <mat-option value="DE">DE Bearing</mat-option>
                                                    <mat-option value="NDE">NDE Bearing</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Temperature Compensation -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Temperature Compensation (°C)</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 1</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_1_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 2</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_2_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Compensation 3</mat-label>
                                                <input matInput type="number" placeholder="0" min="0"
                                                    formControlName="temp_3_comp">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Vibration Compensation -->
                                    <div class="subsection">
                                        <h4 class="subsection-title">Vibration compensation</h4>
                                        <div class="form-fields-row three-columns">
                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Radial (Horizontal)</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_1_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Tangential (Vertical)</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_2_comp">
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="form-field">
                                                <mat-label>Axial</mat-label>
                                                <input matInput type="number" placeholder="1" min="0"
                                                    formControlName="vib_3_comp">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Calibration Status -->
                                    <div class="calibration-status">
                                        <p class="status-text">Last Calibrated: No Calibration Had Been Done Yet</p>
                                        <div class="calibration-actions">
                                            <button mat-stroked-button color="warn" type="button">Reset Values</button>
                                            <button mat-flat-button color="primary" type="button">Calibrate</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- NETWORK CONFIGURATION -->
                             <div class="form-section">
                            <h3 class="form-section-title">Connectivity Configuration</h3>

                            <div formGroupName="network_configuration" class="form-fields-row">

                                <!-- Connectivity Type -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Connectivity Type</mat-label>
                                <input matInput formControlName="connectivity_type" placeholder="Wifi">
                                <mat-error
                                    *ngIf="rotating_asset_form.get('network_configuration.connectivity_type')?.hasError('required')">
                                    Required
                                </mat-error>
                                </mat-form-field>

                                <!-- WiFi SSID -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>WiFi SSID</mat-label>
                                <input matInput formControlName="wifi_ssid" placeholder="Enter SSID">
                                <mat-error
                                    *ngIf="rotating_asset_form.get('network_configuration.wifi_ssid')?.hasError('required')">
                                    WiFi SSID is required
                                </mat-error>
                                </mat-form-field>

                                <!-- WiFi Password -->
                                <mat-form-field appearance="outline" class="form-field">
                                <mat-label>WiFi Password</mat-label>

                                <input matInput 
                                        [type]="hidePassword ? 'password' : 'text'"
                                        formControlName="wifi_password"
                                        placeholder="Enter password">

                                <button mat-icon-button matSuffix type="button"
                                        (click)="hidePassword = !hidePassword"
                                        [attr.aria-label]="'Show/hide password'">
                                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>

                                <mat-error
                                    *ngIf="rotating_asset_form.get('network_configuration.wifi_password')?.hasError('required')">
                                    WiFi password is required
                                </mat-error>

                                </mat-form-field>

                            </div>
                            </div>


                            <!-- Form Actions -->
                            <div class="form-actions">
                                <button mat-flat-button color="warn" type="button" (click)="resetForm()">Clear</button>
                                <button mat-flat-button color="primary" type="button" (click)="saveCurrentAsset()"
                                    [disabled]="rotating_asset_form.invalid">
                                    Save Configuration
                                </button>
                            </div>
                          </ng-template>

                        </form>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>

<app-piezeo-modal-edit *ngIf="modal_type()=='pt_preview'" [modal_type]="'pt_preview'" (close_modal)="closePiezeoPreview()" />


<app-piezeo-modal-edit *ngIf="modal_type()=='add_gateway'" [modal_type]="'add_gateway'" (close_modal)="closeGatewayAdditionModal($event)" />
<app-piezeo-modal-edit *ngIf="modal_type()=='edit_gateway'" [modal_type]="'edit_gateway'" [current_gateway]="current_gateway" (close_modal)="closeGatewayAdditionModal($event)" />



<app-piezeo-modal-edit *ngIf="modal_type()=='piezeo_config'" [current_piezeo]="current_sensor" [current_gateway]="current_gateway" [modal_type]="'piezeo_config'" (close_modal)="closePiezoAdditionModal($event)" />

<!-- 
    - This close function updates the current gateway to who we added/removed associated devices
    - Also updated the all_sensors array to filter unassociated devices only    
-->
<app-piezeo-modal-edit *ngIf="modal_type()=='associate_device_to_gateway'" [gateway_data]="current_gateway"
    [modal_type]="'associate_device_to_gateway'" (close_modal)="handleGatewayAssociationClose($event)" />